import React, { useState, useEffect, useCallback, useRef } from "react";
import Datetime from "react-datetime";
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faDollarSign, faCrown, faBan, faPhone, faSpinner, faUserShield, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Table, Button, Badge, Spinner, Pagination, Modal, Form, Alert } from '@themesberg/react-bootstrap';
import { CircleChartWidget } from "../../components/Widgets";
import { trafficShares } from "../../data/charts";
import { collection, getDocs, query, orderBy, limit, where, doc, getDoc, updateDoc, Timestamp, addDoc, serverTimestamp, setDoc, onSnapshot, writeBatch, getCountFromServer, getAggregateFromServer, sum } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Routes } from "../../routes";
import { resolveChatRoomId } from "../../utils/chatUtils";
import { useAuth } from '../../contexts/AuthContext';

export default () => {
  const { currentUser } = useAuth();
  const history = useHistory();

  // Firebase Auth Custom Claims State
  const [hasAdminClaim, setHasAdminClaim] = useState(null);
  const [loadingClaim, setLoadingClaim] = useState(true);
  const [claimMessage, setClaimMessage] = useState(null);

  const [totalUsers, setTotalUsers] = useState(0);
  const [memberStats, setMemberStats] = useState({
    today: 0,
    last24h: 0,
    last7d: 0,
    last14d: 0,
    last30d: 0,
    total: 0
  });
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [recentPurchases, setRecentPurchases] = useState([]);
  const [lastMembers, setLastMembers] = useState([]);
  const [onlineMembers, setOnlineMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalOnlineCount, setTotalOnlineCount] = useState(0);

  // Online üyeler için sayfalama
  const [currentOnlinePage, setCurrentOnlinePage] = useState(1);
  const itemsPerPage = 5;

  // Modal state'leri
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [targetUserId, setTargetUserId] = useState(null);
  const [targetUserName, setTargetUserName] = useState('');
  const [targetUserCredits, setTargetUserCredits] = useState(0);
  const [targetUserIsBanned, setTargetUserIsBanned] = useState(false);
  const [creditsInput, setCreditsInput] = useState("");
  const [premiumDaysInput, setPremiumDaysInput] = useState("");
  const [modalError, setModalError] = useState(null);

  // Mesaj gönderme modal state'leri
  const [fakeAccounts, setFakeAccounts] = useState([]);
  const [selectedFakeAccountId, setSelectedFakeAccountId] = useState(null);
  const [fakeAccountSearch, setFakeAccountSearch] = useState("");
  const [messageText, setMessageText] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);

  const [earningStartDate, setEarningStartDate] = useState("");
  const [earningEndDate, setEarningEndDate] = useState("");
  const [isFilteringEarnings, setIsFilteringEarnings] = useState(false);
  const [todayEarnings, setTodayEarnings] = useState(0);
  const [earningStats, setEarningStats] = useState({
    last24h: 0,
    last7d: 0,
    last14d: 0,
    last30d: 0,
    total: 0,
    dailyAvgTotal: 0,
    dailyAvg7d: 0,
    dailyAvg14d: 0,
    dailyAvg30d: 0
  });


  // Call başlatma modal state'leri
  const [showCallModal, setShowCallModal] = useState(false);
  const [callType, setCallType] = useState("recorded_voice");
  const [audioRecordings, setAudioRecordings] = useState([]);
  const [videoRecordings, setVideoRecordings] = useState([]);
  const [loadingRecordings, setLoadingRecordings] = useState(false);

  // Refs for modal focus
  const creditsInputRef = useRef(null);
  const premiumInputRef = useRef(null);

  // Coin settings
  const [coinSettings, setCoinSettings] = useState({
    messageCoin: 1,
    imageCoin: 20,
    videoCoin: 0,
    audioCoin: 0,
    callCoin: 150
  });

  const loadUsersCount = useCallback(async () => {
    try {
      const now = new Date();
      // Bugün 00:00:00
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // Son 24 saat
      const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      // Son 7 gün
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      // Son 14 gün
      const fourteenDaysAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
      // Son 30 gün
      const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

      const usersRef = collection(db, 'users');

      // 1. Optimizasyon: Tüm verileri indirmek yerine sunucu tarafı sayım işlemi (getCountFromServer) 
      // Firestore maliyetlerini okuma başına (read) düşürür ve hızı binlerce kat artırır.
      const [
        totalSnap,
        testSnap,
        todaySnap,
        daySnap,
        weekSnap,
        twoWeekSnap,
        monthSnap
      ] = await Promise.all([
        getCountFromServer(usersRef),
        getCountFromServer(query(usersRef, where('isTestUser', '==', true))),
        getCountFromServer(query(usersRef, where('createdAt', '>=', todayStart))),
        getCountFromServer(query(usersRef, where('createdAt', '>=', oneDayAgo))),
        getCountFromServer(query(usersRef, where('createdAt', '>=', sevenDaysAgo))),
        getCountFromServer(query(usersRef, where('createdAt', '>=', fourteenDaysAgo))),
        getCountFromServer(query(usersRef, where('createdAt', '>=', thirtyDaysAgo)))
      ]);

      const testCount = testSnap.data().count;
      // Test hesapları hariç tutulmuş genel toplam
      const total = Math.max(0, totalSnap.data().count - testCount);

      const today = todaySnap.data().count;
      const last24h = daySnap.data().count;
      const last7d = weekSnap.data().count;
      const last14d = twoWeekSnap.data().count;
      const last30d = monthSnap.data().count;

      setTotalUsers(total);
      setMemberStats({
        today,
        last24h,
        last7d,
        last14d,
        last30d,
        total
      });
    } catch (err) {
      console.error("Error loading users count:", err);
    }
  }, []);


  // Gerçek zamanlı online durum takibi için snapshot listener - lastSeen bazlı
  useEffect(() => {
    // Son 5 dakika içinde aktif olanları online kabul et
    const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);

    // Not: Firestore dynamic query update için periyodik yenileme yapılabilir
    // Ancak onSnapshot zaten veriler değiştikçe tetiklenir.
    // isOnline hala bir ipucu olarak kullanılabilir ama lastSeen ana belirleyicidir.
    const q = query(
      collection(db, 'users'),
      where('lastSeen', '>=', Timestamp.fromDate(fiveMinutesAgo))
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        let count = 0;
        const allOnline = [];
        const now = Date.now();
        const activeThreshold = 5 * 60 * 1000; // 5 dakika

        snapshot.forEach(doc => {
          const data = doc.data();
          const lastSeenDate = data.lastSeen?.toDate ? data.lastSeen.toDate() : (data.lastSeen ? new Date(data.lastSeen) : null);
          const isRecentlyActive = lastSeenDate && (now - lastSeenDate.getTime() < activeThreshold);

          // isTestUser field'ı yoksa veya false ise gerçek kullanıcı olarak kabul et
          if (data.isTestUser !== true && data.isAdmin !== true && isRecentlyActive) {
            count++;
            allOnline.push({
              id: doc.id,
              name: data.name || '',
              status: true,
              credit: data.credits || 0,
              isPremium: data.isPremium || false, // ✅ VIP DURUMU
              profileImageUrl: data.profileImageUrl || null,
              lastSeen: data.lastSeen || null
            });
          }
        });
        setOnlineUsers(count);

        // lastSeen'e göre sırala (en son aktif olanlar önce)
        allOnline.sort((a, b) => {
          if (!a.lastSeen && !b.lastSeen) return 0;
          if (!a.lastSeen) return 1;
          if (!b.lastSeen) return -1;
          const aTime = a.lastSeen.toDate ? a.lastSeen.toDate().getTime() : new Date(a.lastSeen).getTime();
          const bTime = b.lastSeen.toDate ? b.lastSeen.toDate().getTime() : new Date(b.lastSeen).getTime();
          return bTime - aTime; // En yeni önce
        });

        setTotalOnlineCount(allOnline.length);

        const startIndex = (currentOnlinePage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setOnlineMembers(allOnline.slice(startIndex, endIndex));
      },
      (err) => {
        console.error('Error listening to online users:', err);
      }
    );

    return () => unsubscribe();
  }, [currentOnlinePage, itemsPerPage]);

  const loadTotalEarnings = useCallback(async () => {
    try {
      setIsFilteringEarnings(true);
      let total = 0;
      let todayAfter6 = 0;
      let last24h = 0;
      let last7d = 0;
      let last14d = 0;
      let last30d = 0;

      const now = new Date();
      const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      const fourteenDaysAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
      const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

      // Uygulama yayın tarihi 11.05.2026
      const launchDate = new Date('2026-05-11T00:00:00');
      const daysSinceLaunch = Math.max(1, Math.ceil((now.getTime() - launchDate.getTime()) / (1000 * 3600 * 24)));

      // 06:00 - Ertesi gün 06:00 vardiya hesabı
      let currentShiftStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 6, 0, 0);
      let currentShiftEnd = new Date(currentShiftStart);
      if (now.getHours() < 6) {
        currentShiftStart.setDate(currentShiftStart.getDate() - 1);
        currentShiftEnd.setDate(currentShiftEnd.getDate() - 1);
      }
      currentShiftEnd.setDate(currentShiftEnd.getDate() + 1);

      const filterStart = earningStartDate ? new Date(earningStartDate) : null;
      const filterEnd   = earningEndDate   ? new Date(earningEndDate)   : null;

      // ─── Filtre YOKSA: Tüm koleksiyonları sunucu tarafında topla ─────────────
      if (!earningStartDate && !earningEndDate) {
        try {
          const [purchasesAgg, vipAgg] = await Promise.all([
            getAggregateFromServer(collection(db, 'purchases'), { totalPrice: sum('price') }),
            getAggregateFromServer(collection(db, 'vipPackagePayments'), { totalPrice: sum('price') })
          ]);
          const creditTotal = purchasesAgg.data().totalPrice || 0;
          const vipTotal    = vipAgg.data().totalPrice    || 0;
          total = creditTotal + vipTotal;
        } catch (aggErr) {
          console.warn("Aggregate query failed, falling back to doc scan:", aggErr);
          const [pSnap, vSnap] = await Promise.all([
            getDocs(collection(db, 'purchases')),
            getDocs(collection(db, 'vipPackagePayments'))
          ]);
          pSnap.forEach(d => total += parseFloat(String(d.data().price || 0).replace(',', '.')));
          vSnap.forEach(d => {
            const s = d.data().status;
            if (!s || s === "Başarılı Alım" || s === "Başarılı Ödeme") {
              total += parseFloat(String(d.data().price || 0).replace(',', '.'));
            }
          });
        }

        // Detaylıı istatistikler için son 30 günlük tüm alımları çekelim
        const [pRecentSnap, vRecentSnap] = await Promise.all([
          getDocs(query(collection(db, 'purchases'), where('createdAt', '>=', thirtyDaysAgo))),
          getDocs(query(collection(db, 'vipPackagePayments'), where('createdAt', '>=', thirtyDaysAgo)))
        ]);

        const processRecentDoc = (d, isVip) => {
          const data = d.data();
          if (isVip) {
            const s = data.status;
            if (s && s !== "Başarılı Alım" && s !== "Başarılı Ödeme") return;
          }
          const price = parseFloat(String(data.price || 0).replace(',', '.'));
          const createdAt = data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || data.date || 0);

          if (createdAt >= thirtyDaysAgo) last30d += price;
          if (createdAt >= fourteenDaysAgo) last14d += price;
          if (createdAt >= sevenDaysAgo) last7d += price;
          if (createdAt >= oneDayAgo) last24h += price;
          if (createdAt >= currentShiftStart && createdAt < currentShiftEnd) todayAfter6 += price;
        };

        pRecentSnap.forEach(d => processRecentDoc(d, false));
        vRecentSnap.forEach(d => processRecentDoc(d, true));

      } else {
        // ─── Filtre VARSA: Sadece seçilen tarih aralığını çek ─────────────────
        const fetchFrom = filterStart || currentShiftStart;

        const [pSnap, vSnap] = await Promise.all([
          getDocs(query(collection(db, 'purchases'),          where('createdAt', '>=', fetchFrom))),
          getDocs(query(collection(db, 'vipPackagePayments'), where('createdAt', '>=', fetchFrom)))
        ]);

        const processDoc = (d, isVip) => {
          const data = d.data();
          if (isVip) {
            const s = data.status;
            if (s && s !== "Başarılı Alım" && s !== "Başarılı Ödeme") return;
          }
          const price = parseFloat(String(data.price || 0).replace(',', '.'));
          const createdAt = data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || data.date || 0);
          
          const inRange = (!filterStart || createdAt >= filterStart) && (!filterEnd || createdAt <= filterEnd);
          if (inRange) total += price;
          if (createdAt >= currentShiftStart && createdAt < currentShiftEnd) todayAfter6 += price;
        };

        pSnap.forEach(d => processDoc(d, false));
        vSnap.forEach(d => processDoc(d, true));
      }

      const formatNumber = (num) => Math.round(num * 100) / 100;

      setTotalEarnings(formatNumber(total));
      setTodayEarnings(formatNumber(todayAfter6));
      setEarningStats({
        last24h: formatNumber(last24h),
        last7d: formatNumber(last7d),
        last14d: formatNumber(last14d),
        last30d: formatNumber(last30d),
        total: formatNumber(total),
        dailyAvgTotal: formatNumber(total / daysSinceLaunch),
        dailyAvg7d: formatNumber(last7d / 7),
        dailyAvg14d: formatNumber(last14d / 14),
        dailyAvg30d: formatNumber(last30d / 30)
      });
    } catch (err) {
      console.error("Error loading total earnings:", err);
    } finally {
      setIsFilteringEarnings(false);
    }
  }, [earningStartDate, earningEndDate]);


  const loadRecentPurchases = useCallback(async () => {
    try {
      // Kredi paketleri
      const qPurchases = query(
        collection(db, 'purchases'),
        orderBy('createdAt', 'desc'),
        limit(5)
      );
      const purchasesSnapshot = await getDocs(qPurchases);
      const combinedPurchases = [];

      purchasesSnapshot.docs.forEach((doc) => {
        const data = doc.data() || {};
        combinedPurchases.push({
          ...data,
          id: doc.id,
          type: 'credit',
          dateObj: data.createdAt?.toDate() || new Date(0)
        });
      });

      // VIP paketleri
      const qVip = query(
        collection(db, 'vipPackagePayments'),
        orderBy('createdAt', 'desc'),
        limit(5)
      );
      const vipSnapshot = await getDocs(qVip);
      vipSnapshot.docs.forEach((doc) => {
        const data = doc.data() || {};
        // Sadece başarılı alımları göster
        if (data.status === "Başarılı Alım" || data.status === "Başarılı Ödeme" || !data.status) {
          combinedPurchases.push({
            ...data,
            id: doc.id,
            type: 'vip',
            dateObj: data.createdAt?.toDate() || data.date?.toDate() || new Date(0)
          });
        }
      });

      // Birleştir ve sırala
      combinedPurchases.sort((a, b) => b.dateObj - a.dateObj);

      // İlk 5'i al ve formatla
      const purchases = combinedPurchases.slice(0, 5).map((data, index) => {
        const price = Math.floor(parseFloat(data.price || 0)).toLocaleString('tr-TR');
        return {
          id: data.id || index + 1,
          user: (data.userName || 'İsimsiz').split(' ')[0], // Sadece ilk ismi göstermek isterseniz
          paket: data.type === 'vip' ? 'VIP' : data.type === 'verified_badge' ? 'Rozet/Ses' : `${data.coinAmount || 0} Kredi`,
          credit: `${price} TL`,
          saat: (data.dateObj.getHours().toString().padStart(2, '0')) + ":" + (data.dateObj.getMinutes().toString().padStart(2, '0'))
        };
      });

      setRecentPurchases(purchases);
    } catch (err) {
      console.error("Error loading recent purchases:", err);
    }
  }, []);

  // Gerçek zamanlı son üyeler listesi için onSnapshot kullan
  useEffect(() => {
    // Tüm kullanıcıları dinlemek yerine sadece en son eklenenleri (limitli) dinle
    const recentUsersQuery = query(
      collection(db, 'users'),
      orderBy('createdAt', 'desc'),
      limit(20) // Test hesaplarını ayıklayabilmek adına 5 yerine 20 limit veriyoruz
    );

    const unsubscribe = onSnapshot(
      recentUsersQuery,
      (snapshot) => {
        try {
          const allMembers = [];

          snapshot.forEach((doc) => {
            const data = doc.data();
            // Fake hesapları (isTestUser === true) ve admin hesaplarını hariç tut
            if (data.isTestUser !== true && data.isAdmin !== true) {
              allMembers.push({
                userId: doc.id,
                name: data.name || '',
                status: data.isApproved || false,
                isOnline: data.isOnline === true,
                credit: data.credits || 0,
                isPremium: data.isPremium || false,
                profileImageUrl: data.profileImageUrl || null,
                createdAt: data.createdAt || data.updatedAt || null,
                lastSeen: data.lastSeen || null
              });
            }
          });

          // İlk 5 üyeyi al ve id ekle
          const members = allMembers.slice(0, 5).map((member, index) => ({
            ...member,
            id: index + 1
          }));

          setLastMembers(members);
        } catch (err) {
          console.error("Error loading last members:", err);
          setLastMembers([]);
        }
      },
      (err) => {
        console.error("Error listening to last members:", err);
        setLastMembers([]);
      }
    );

    return () => unsubscribe();
  }, []);

  const loadOnlineMembers = useCallback(async () => {
    try {
      const q = query(
        collection(db, 'users'),
        where('isOnline', '==', true)
      );
      const snapshot = await getDocs(q);
      const allOnline = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data.isTestUser !== true) {
          allOnline.push({
            id: doc.id,
            name: data.name || '',
            status: true,
            credit: data.credits || 0,
            profileImageUrl: data.profileImageUrl || null,
            lastSeen: data.lastSeen || null
          });
        }
      });

      // lastSeen'e göre sırala (en son aktif olanlar önce)
      allOnline.sort((a, b) => {
        if (!a.lastSeen && !b.lastSeen) return 0;
        if (!a.lastSeen) return 1;
        if (!b.lastSeen) return -1;
        const aTime = a.lastSeen.toDate ? a.lastSeen.toDate().getTime() : new Date(a.lastSeen).getTime();
        const bTime = b.lastSeen.toDate ? b.lastSeen.toDate().getTime() : new Date(b.lastSeen).getTime();
        return bTime - aTime; // En yeni önce
      });

      setTotalOnlineCount(allOnline.length);

      const startIndex = (currentOnlinePage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setOnlineMembers(allOnline.slice(startIndex, endIndex));
    } catch (err) {
      console.error('Error loading online members, falling back to all users:', err);
      const q = query(
        collection(db, 'users')
      );
      const snapshot = await getDocs(q);
      const allUsers = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data.isTestUser !== true) {
          allUsers.push({
            id: doc.id,
            name: data.name || '',
            status: data.isOnline || false,
            credit: data.credits || 0,
            profileImageUrl: data.profileImageUrl || null
          });
        }
      });

      setTotalOnlineCount(allUsers.length);

      const startIndex = (currentOnlinePage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setOnlineMembers(allUsers.slice(startIndex, endIndex));
    }
  }, [currentOnlinePage, itemsPerPage]);

  // Online üyeleri sıfırlama fonksiyonu
  const handleResetOnlineUsers = async () => {
    if (!window.confirm('Tüm kullanıcıların online durumunu sıfırlamak istediğinizden emin misiniz? Gerçekten online olanlar tekrar online olacaktır.')) {
      return;
    }

    try {
      setLoading(true);
      // Tüm kullanıcıları çek
      const snapshot = await getDocs(collection(db, 'users'));
      const updates = [];
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        // Fake hesapları atla
        if (data.isTestUser !== true) {
          updates.push({ ref: docSnap.ref, isOnline: false });
        }
      });

      // Batch işlemleri (Firestore batch limit: 500)
      const maxBatchSize = 500;
      for (let i = 0; i < updates.length; i += maxBatchSize) {
        const batch = writeBatch(db);
        const batchUpdates = updates.slice(i, i + maxBatchSize);

        batchUpdates.forEach((update) => {
          batch.update(update.ref, {
            isOnline: false
          });
        });

        await batch.commit();
      }

      // Online üyeler gerçek zamanlı listener tarafından otomatik güncelleniyor
      // loadOnlineUsersCount da listener tarafından otomatik güncelleniyor

      alert('Online durumlar sıfırlandı. Gerçekten online olan kullanıcılar tekrar online olacaktır.');
    } catch (err) {
      console.error('Error resetting online users:', err);
      alert('Online durumlar sıfırlanırken bir hata oluştu: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Firebase Auth Custom Claims kontrolü
  useEffect(() => {
    const checkAdminClaim = async () => {
      if (!currentUser) {
        setLoadingClaim(false);
        return;
      }

      try {
        const token = await currentUser.getIdTokenResult();
        const hasClaim = token.claims.admin === true;
        setHasAdminClaim(hasClaim);
        setLoadingClaim(false);
      } catch (error) {
        console.error('Error checking admin claim:', error);
        setHasAdminClaim(false);
        setLoadingClaim(false);
      }
    };

    checkAdminClaim();
  }, [currentUser]);

  // setAdminClaims fonksiyonu
  const setAdminClaims = async () => {
    if (!currentUser) return;

    setLoadingClaim(true);
    setClaimMessage(null);

    try {
      const functions = getFunctions();
      const setAdminClaimsFunction = httpsCallable(functions, 'setAdminClaims');

      const result = await setAdminClaimsFunction({ uid: currentUser.uid });

      if (result.data.success) {
        setClaimMessage({ type: 'success', text: 'Admin yetkisi başarıyla verildi! Sayfayı yenileyin.' });
        setHasAdminClaim(true);

        // Token'ı yenile
        await currentUser.getIdToken(true);
      } else {
        setClaimMessage({ type: 'danger', text: result.data.message || 'Hata oluştu' });
      }
    } catch (error) {
      console.error('Error setting admin claims:', error);
      setClaimMessage({ type: 'danger', text: 'Hata: ' + error.message });
    } finally {
      setLoadingClaim(false);
    }
  };

  // Coin settings yükle
  const loadCoinSettings = useCallback(async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'coinSettings'));
      if (settingsDoc.exists()) {
        const data = settingsDoc.data();
        setCoinSettings({
          messageCoin: data.messageCoin || 1,
          imageCoin: data.imageCoin || 20,
          videoCoin: data.videoCoin || 0,
          audioCoin: data.voiceCoin || 0,
          callCoin: data.callCoin || 150
        });
      }
    } catch (err) {
      console.error('Error loading coin settings:', err);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          loadUsersCount(),
          loadCoinSettings(),
          loadTotalEarnings(),
          loadRecentPurchases()
          // loadLastMembers artık gerçek zamanlı listener tarafından otomatik olarak yönetiliyor
        ]);
      } catch (err) {
        console.error("Error loading dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [loadUsersCount, loadCoinSettings]); // Removed loadTotalEarnings, loadRecentPurchases from dependencies

  useEffect(() => {
    loadTotalEarnings();
  }, [loadTotalEarnings, earningStartDate, earningEndDate]);

  useEffect(() => {
    loadRecentPurchases();
  }, [loadRecentPurchases]);

  // loadOnlineMembers artık gerçek zamanlı listener tarafından otomatik olarak yönetiliyor
  // İlk yükleme için listener yeterli, bu useEffect'i kaldırdık

  const totalOnlinePages = Math.ceil(totalOnlineCount / itemsPerPage);

  // Fake hesapları yükle
  const loadFakeAccounts = useCallback(async () => {
    try {
      const snapshot = await getDocs(query(collection(db, 'users'), where('isTestUser', '==', true)));
      const accounts = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        accounts.push({
          id: doc.id,
          name: data.name || 'İsimsiz',
          profileImageUrl: data.profileImageUrl || null
        });
      });
      // İsme göre sırala
      accounts.sort((a, b) => a.name.localeCompare(b.name, 'tr'));
      setFakeAccounts(accounts);
      // İlk fake hesabı varsayılan olarak seç
      if (accounts.length > 0 && !selectedFakeAccountId) {
        setSelectedFakeAccountId(accounts[0].id);
      }
    } catch (err) {
      console.error('Error loading fake accounts:', err);
    }
  }, [selectedFakeAccountId]);

  // Mesaj modal'ını aç
  const openMessageModal = async (userId, userName) => {
    setTargetUserId(userId);
    setTargetUserName(userName);
    setMessageText("");
    setFakeAccountSearch("");
    setModalError(null);
    await loadFakeAccounts();
    setShowMessageModal(true);
  };

  // Call modal'ını aç
  const openCallModal = async (userId, userName) => {
    setTargetUserId(userId);
    setTargetUserName(userName);
    setModalError(null);
    setCallType("normal_voice");
    await loadFakeAccounts();
    // İlk fake hesap seçilirse kayıtları yükle
    if (fakeAccounts.length > 0 && !selectedFakeAccountId) {
      setSelectedFakeAccountId(fakeAccounts[0].id);
    }
    setShowCallModal(true);
  };

  // Kayıtları yükle (fake hesap için)
  const loadRecordings = async (fakeAccountId) => {
    if (!fakeAccountId) return;

    try {
      setLoadingRecordings(true);

      // Ses kayıtlarını yükle
      const audioRef = collection(db, 'users', fakeAccountId, 'audioRecordings');
      const audioSnapshot = await getDocs(audioRef);
      const audioList = [];
      audioSnapshot.forEach(doc => {
        const data = doc.data();
        audioList.push({
          id: doc.id,
          title: data.title || 'İsimsiz',
          fileUrl: data.fileUrl || '',
          createdAt: data.createdAt
        });
      });
      setAudioRecordings(audioList);

      // Video kayıtlarını yükle
      const videoRef = collection(db, 'users', fakeAccountId, 'videoRecordings');
      const videoSnapshot = await getDocs(videoRef);
      const videoList = [];
      videoSnapshot.forEach(doc => {
        const data = doc.data();
        videoList.push({
          id: doc.id,
          title: data.title || 'İsimsiz',
          fileUrl: data.fileUrl || '',
          createdAt: data.createdAt
        });
      });
      setVideoRecordings(videoList);
    } catch (err) {
      console.error('Error loading recordings:', err);
      setModalError('Kayıtlar yüklenirken bir hata oluştu: ' + err.message);
    } finally {
      setLoadingRecordings(false);
    }
  };

  // Call başlatma fonksiyonu
  const handleStartCall = async () => {
    if (!targetUserId || !selectedFakeAccountId) {
      setModalError('Lütfen fake hesap seçin.');
      return;
    }

    try {
      setModalError(null);

      let mediaUrl = null;

      if (callType === 'normal_voice') {
        // Normal arama - kayıt gerekmez
        mediaUrl = null;
      } else if (callType === 'recorded_voice') {
        if (audioRecordings.length === 0) {
          setModalError('Ses kaydı bulunamadı.');
          return;
        }
        mediaUrl = audioRecordings[0].fileUrl;
      } else if (callType === 'recorded_video') {
        if (videoRecordings.length === 0) {
          setModalError('Video kaydı bulunamadı.');
          return;
        }
        mediaUrl = videoRecordings[0].fileUrl;
      }

      const callRequestsRef = collection(db, 'callRequests');
      const callRequestData = {
        callerId: selectedFakeAccountId, // Arayan hesap
        receiverId: targetUserId, // Alıcı kullanıcı
        type: callType === 'recorded_video' ? 'video' : 'voice',
        // callMode kaldırıldı - Android'e gitmemeli
        // mediaUrl varsa oynatılır, yoksa normal arama gibi davranılır
        mediaUrl: mediaUrl,
        status: 'ringing',
        createdAt: serverTimestamp()
      };

      await addDoc(callRequestsRef, callRequestData);
      setShowCallModal(false);
      setModalError(null);
    } catch (err) {
      console.error('Error starting call:', err);
      setModalError('Arama başlatılırken bir hata oluştu: ' + err.message);
    }
  };

  // Mesaj gönderme fonksiyonu
  const handleSendMessage = async (navigateToChat = false) => {
    if (!targetUserId || !selectedFakeAccountId || !messageText.trim()) {
      setModalError('Lütfen fake hesap seçin ve mesaj yazın.');
      return;
    }

    try {
      setSendingMessage(true);
      setModalError(null);

      const fakeAccountId = selectedFakeAccountId;
      const userId = targetUserId;

      // roomId'yi hesapla (alfabetik sıraya göre)
      const calculatedRoomId = await resolveChatRoomId(fakeAccountId, userId);

      // Mesajı gönder
      const messagesRef = collection(db, 'chatRooms', calculatedRoomId, 'messages');
      await addDoc(messagesRef, {
        senderId: fakeAccountId, // Fake hesap gönderen
        receiverId: userId, // Kullanıcı alıcı
        message: messageText.trim(),
        timestamp: serverTimestamp(),
        type: 'text'
      });

      // Chat room'u güncelle/oluştur
      const roomRef = doc(db, 'chatRooms', calculatedRoomId);
      const roomDoc = await getDoc(roomRef);

      if (roomDoc.exists()) {
        await updateDoc(roomRef, {
          participantUids: [fakeAccountId, userId],
          lastMessage: messageText.trim(),
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'text',
          lastMessageSenderId: fakeAccountId,
          ignoredAt: null
        });
      } else {
        await setDoc(roomRef, {
          participantUids: [fakeAccountId, userId],
          lastMessage: messageText.trim(),
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'text',
          lastMessageSenderId: fakeAccountId,
          ignoredAt: null,
          createdAt: serverTimestamp()
        });
      }

      // Modal'ı kapat
      setShowMessageModal(false);
      setMessageText("");
      setFakeAccountSearch("");
      setSendingMessage(false);

      // Chat'e git seçildiyse yönlendir
      if (navigateToChat) {
        // Fake hesap ID'sini receiverId, kullanıcı ID'sini senderId olarak geçir
        history.push(`/messages/quick-unreplied?roomId=${calculatedRoomId}&receiverId=${fakeAccountId}&senderId=${userId}`);
      }
    } catch (err) {
      console.error('Error sending message:', err);
      setModalError('Mesaj gönderilirken bir hata oluştu: ' + err.message);
      setSendingMessage(false);
    }
  };

  // Modal açma fonksiyonları
  const openCreditsModal = async (userId, userName, currentCredits) => {
    setTargetUserId(userId);
    setTargetUserName(userName);
    setTargetUserCredits(currentCredits);
    setCreditsInput("");
    setModalError(null);
    setShowCreditsModal(true);
  };

  const openPremiumModal = async (userId, userName, isPremium) => {
    setTargetUserId(userId);
    setTargetUserName(userName);
    setPremiumDaysInput("");
    setModalError(null);
    setShowPremiumModal(true);
  };

  const openBanModal = async (userId, userName, isBanned) => {
    setTargetUserId(userId);
    setTargetUserName(userName);
    setTargetUserIsBanned(isBanned);
    setModalError(null);
    setShowBanModal(true);
  };

  // Modal işlem fonksiyonları
  const handleUpdateCredits = async () => {
    if (!targetUserId) return;

    try {
      const creditsChange = parseInt(creditsInput);
      if (isNaN(creditsChange)) {
        setModalError('Geçerli bir jeton değeri girin.');
        return;
      }

      const userRef = doc(db, 'users', targetUserId);
      const userDoc = await getDoc(userRef);
      const currentCredits = userDoc.data()?.credits || 0;
      const newCredits = Math.max(0, currentCredits + creditsChange);

      await updateDoc(userRef, {
        credits: newCredits
      });

      // Son üyeler ve online üyeler gerçek zamanlı listener tarafından otomatik güncelleniyor

      setShowCreditsModal(false);
      setCreditsInput("");
      setTargetUserId(null);
      setModalError(null);
    } catch (err) {
      console.error('Error updating credits:', err);
      setModalError('Jeton güncellenirken bir hata oluştu.');
    }
  };

  const handleUpdatePremium = async () => {
    if (!targetUserId) return;

    try {
      const days = parseInt(premiumDaysInput);
      if (isNaN(days) || days < 0) {
        setModalError('Geçerli bir gün sayısı girin.');
        return;
      }

      const userRef = doc(db, 'users', targetUserId);
      let newExpiresAt = null;

      if (days > 0) {
        const now = new Date();
        const expiresAt = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
        newExpiresAt = Timestamp.fromDate(expiresAt);
      }

      await updateDoc(userRef, {
        isPremium: days > 0,
        premiumExpiresAt: newExpiresAt
      });

      // Son üyeler ve online üyeler gerçek zamanlı listener tarafından otomatik güncelleniyor

      setShowPremiumModal(false);
      setPremiumDaysInput("");
      setTargetUserId(null);
      setModalError(null);
    } catch (err) {
      console.error('Error updating premium:', err);
      setModalError('Premium durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleBanUser = async () => {
    if (!targetUserId) return;

    try {
      const userRef = doc(db, 'users', targetUserId);
      await updateDoc(userRef, {
        isBanned: !targetUserIsBanned
      });

      // Son üyeler ve online üyeler gerçek zamanlı listener tarafından otomatik güncelleniyor

      setShowBanModal(false);
      setTargetUserId(null);
      setModalError(null);
    } catch (err) {
      console.error('Error banning user:', err);
      setModalError('Kullanıcı ban durumu güncellenirken bir hata oluştu.');
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      {/* Firebase Auth Custom Claims Uyarısı */}
      {!loadingClaim && hasAdminClaim === false && (
        <Alert variant="warning" className="mb-4">
          <h5><FontAwesomeIcon icon={faUserShield} className="me-2" />Firebase Auth Admin Yetkisi Eksik!</h5>
          <p className="mb-3">
            Firestore'da admin olarak tanımlı olsanız da, Firebase Auth token'ınızda admin claim'i bulunmuyor.
            Bu nedenle bazı işlemler (cevapsız mesajlar, vb.) "Missing or insufficient permissions" hatası verebilir.
          </p>
          <Button
            variant="primary"
            onClick={setAdminClaims}
            disabled={loadingClaim}
          >
            {loadingClaim ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Admin Yetkisi Veriliyor...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faUserShield} className="me-2" />
                Admin Yetkisi Ver
              </>
            )}
          </Button>
          {claimMessage && (
            <Alert variant={claimMessage.type} className="mt-3 mb-0">
              {claimMessage.text}
            </Alert>
          )}
        </Alert>
      )}

      {!loadingClaim && hasAdminClaim === true && (
        <Alert variant="success" className="mb-4">
          <FontAwesomeIcon icon={faUserShield} className="me-2" />
          Firebase Auth admin yetkisi aktif! Tüm özelliklere erişebilirsiniz.
        </Alert>
      )}

      <div className="py-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Anasayfa</h4>
        <div className="fw-bold text-success fs-5 d-none d-lg-block" style={{opacity: 0.5}}><FontAwesomeIcon icon={faCheckCircle} /> Online: {onlineUsers.toLocaleString('tr-TR')}</div>
      </div>

      

      <Row className="mb-4">
        {/* Kullanıcı İstatistikleri */}
        <Col xs={12} lg={6} className="mb-4">
          <Card border="0" className="shadow-sm h-100">
            <Card.Header className="border-bottom">
              <h5 className="mb-0">Detaylı Üye İstatistikleri</h5>
            </Card.Header>
            <Card.Body>
              <div className="d-flex flex-wrap justify-content-between text-center gap-2">
                <div className="p-3 bg-light rounded flex-fill">
                  <h3 className="mb-1 text-primary">{memberStats.today.toLocaleString('tr-TR')}</h3>
                  <small className="text-muted fw-bold">Bugün (00:00 sonrası)</small>
                </div>
                <div className="p-3 bg-light rounded flex-fill">
                  <h3 className="mb-1 text-success">{memberStats.last7d.toLocaleString('tr-TR')}</h3>
                  <small className="text-muted fw-bold">Son 7 Gün</small>
                </div>
                <div className="p-3 bg-light rounded flex-fill">
                  <h3 className="mb-1 text-warning">{memberStats.last14d.toLocaleString('tr-TR')}</h3>
                  <small className="text-muted fw-bold">Son 14 Gün</small>
                </div>
                <div className="p-3 bg-light rounded flex-fill">
                  <h3 className="mb-1 text-danger">{memberStats.last30d.toLocaleString('tr-TR')}</h3>
                  <small className="text-muted fw-bold">Son 30 Gün</small>
                </div>
              </div>
              
              <div className="mt-4 p-4 bg-white rounded text-center border shadow-sm d-flex align-items-center justify-content-center">
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>
                  <span className="text-success me-2">●</span> Online Üye: <span className="text-primary">{onlineUsers.toLocaleString('tr-TR')}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Gelir İstatistikleri */}
        <Col xs={12} lg={6} className="mb-4">
          <Card border="0" className="shadow-sm h-100">
            <Card.Header className="border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h5 className="mb-0">
                {isFilteringEarnings ? (
                  <Spinner animation="border" size="sm" className="me-2" />
                ) : null}
                Detaylı Gelir İstatistikleri (Ortalamalı)
              </h5>
              <div className="d-flex gap-2 flex-wrap align-items-center">
                <div className="d-flex align-items-center">
                  <small className="me-1 text-muted">Baş:</small>
                  <input
                    type="datetime-local"
                    className="form-control form-control-sm"
                    style={{ width: '150px', fontSize: '0.85rem' }}
                    value={earningStartDate}
                    onChange={(e) => setEarningStartDate(e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <small className="me-1 text-muted">Bit:</small>
                  <input
                    type="datetime-local"
                    className="form-control form-control-sm"
                    style={{ width: '150px', fontSize: '0.85rem' }}
                    value={earningEndDate}
                    onChange={(e) => setEarningEndDate(e.target.value)}
                  />
                </div>
                {(earningStartDate || earningEndDate) && (
                  <Button
                    variant="link"
                    size="sm"
                    className="text-danger p-0 ms-1"
                    onClick={() => {
                      setEarningStartDate("");
                      setEarningEndDate("");
                    }}
                  >
                    Sıfırla
                  </Button>
                )}
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table className="table-hover mb-0 align-items-center" style={{ fontSize: '0.95rem' }}>
                  <thead className="bg-light">
                    <tr>
                      <th className="border-0 text-uppercase text-secondary fw-bold">Zaman Dilimi</th>
                      <th className="border-0 text-uppercase text-secondary fw-bold">Toplam Gelir</th>
                      <th className="border-0 text-uppercase text-secondary fw-bold">Günlük Ortalama</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fw-bold text-dark">06:00 Sonrası</td>
                      <td className="text-success fw-bold">{Math.floor(todayEarnings).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">-</td>
                    </tr>
                    <tr>
                      <td className="fw-bold text-dark">Son 24 Saat</td>
                      <td className="text-success fw-bold">{Math.floor(earningStats.last24h).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">{Math.floor(earningStats.last24h).toLocaleString('tr-TR')} TL / gün</td>
                    </tr>
                    <tr>
                      <td className="fw-bold text-dark">Son 7 Gün</td>
                      <td className="text-success fw-bold">{Math.floor(earningStats.last7d).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">{Math.floor(earningStats.dailyAvg7d).toLocaleString('tr-TR')} TL / gün</td>
                    </tr>
                    <tr>
                      <td className="fw-bold text-dark">Son 14 Gün</td>
                      <td className="text-success fw-bold">{Math.floor(earningStats.last14d).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">{Math.floor(earningStats.dailyAvg14d).toLocaleString('tr-TR')} TL / gün</td>
                    </tr>
                    <tr>
                      <td className="fw-bold text-dark">Son 30 Gün</td>
                      <td className="text-success fw-bold">{Math.floor(earningStats.last30d).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">{Math.floor(earningStats.dailyAvg30d).toLocaleString('tr-TR')} TL / gün</td>
                    </tr>
                    <tr className="bg-light">
                      <td className="fw-bold text-dark">Tüm Zamanlar <small className="text-muted fw-normal">(11.05.2026'dan beri)</small></td>
                      <td className="text-success fw-bold">{Math.floor(earningStats.total).toLocaleString('tr-TR')} TL</td>
                      <td className="text-muted fw-bold">{Math.floor(earningStats.dailyAvgTotal).toLocaleString('tr-TR')} TL / gün</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={12} className="mb-4">
          <Card border="0" className="shadow-sm">
            <Card.Header className="border-bottom">
              <h5 className="mb-0">Son Satın Alımlar</h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                  <thead>
                    <tr>
                      <th className="border-0">Kullanıcı</th>
                      <th className="border-0">Paket</th>
                      <th className="border-0">Tutar</th>
                      <th className="border-0">Saat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentPurchases.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center p-4">Henüz satın alma yok.</td>
                      </tr>
                    ) : (
                      recentPurchases.map((purchase) => (
                        <tr key={purchase.id}>
                          <td>{purchase.user}</td>
                          <td>{purchase.paket}</td>
                          <td>{purchase.credit}</td>
                          <td>{purchase.saat}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>


      <Row>
        <Col xs={12} lg={6} className="mb-4">
          <Card border="0" className="shadow-sm">
            <Card.Header className="border-bottom">
              <h5 className="mb-0">Son Üyeler</h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                  <thead>
                    <tr>
                      <th className="border-0">Sıra</th>
                      <th className="border-0">Kullanıcı</th>
                      <th className="border-0">Durum</th>
                      <th className="border-0">Kredi</th>
                      <th className="border-0">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lastMembers.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center p-4">Henüz üye yok.</td>
                      </tr>
                    ) : (
                      lastMembers.map((member) => (
                        <tr key={member.userId || member.id}>
                          <td>{member.id}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {member.profileImageUrl ? (
                                <img
                                  src={member.profileImageUrl}
                                  alt={member.name}
                                  className="rounded-circle"
                                  style={{ width: 32, height: 32, marginRight: 8, objectFit: 'cover' }}
                                />
                              ) : (
                                <div className="rounded-circle bg-secondary" style={{ width: 32, height: 32, marginRight: 8 }}></div>
                              )}
                              {member.name}
                              {member.isPremium && (
                                <Badge bg="warning" text="dark" className="ms-2" style={{ fontSize: '0.7rem' }}>VİP</Badge>
                              )}
                            </div>
                          </td>
                          <td>
                            {(() => {
                              const lastSeen = member.lastSeen;
                              const isOnline = lastSeen && (Date.now() - (lastSeen.toDate ? lastSeen.toDate() : new Date(lastSeen)).getTime() < 5 * 60 * 1000);
                              return (
                                <FontAwesomeIcon
                                  icon={isOnline ? faCheckCircle : faTimesCircle}
                                  className={isOnline ? "text-success" : "text-danger"}
                                  title={isOnline ? "Çevrimiçi" : "Çevrimdışı"}
                                />
                              );
                            })()}
                          </td>
                          <td>{member.credit}</td>
                          <td>
                            <div className="d-flex gap-1 flex-wrap">
                              <Button
                                size="sm"
                                variant="info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openMessageModal(member.userId, member.name);
                                }}
                              >
                                <FontAwesomeIcon icon={faPhone} className="me-1" />
                                Mesaj
                              </Button>
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openCallModal(member.userId, member.name);
                                }}
                              >
                                <FontAwesomeIcon icon={faPhone} className="me-1" />
                                Arama
                              </Button>
                              <Button
                                size="sm"
                                variant="success"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openCreditsModal(member.userId, member.name, member.credit);
                                }}
                              >
                                <FontAwesomeIcon icon={faDollarSign} />
                              </Button>
                              <Button
                                size="sm"
                                variant="warning"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openPremiumModal(member.userId, member.name, false);
                                }}
                              >
                                <FontAwesomeIcon icon={faCrown} />
                              </Button>
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openBanModal(member.userId, member.name, false);
                                }}
                              >
                                <FontAwesomeIcon icon={faBan} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={6} className="mb-4">
          <Card border="0" className="shadow-sm">
            <Card.Header className="border-bottom d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Çevrim İçi Üyeler</h5>
              <Button
                variant="warning"
                size="sm"
                onClick={handleResetOnlineUsers}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" />
                    Sıfırlanıyor...
                  </>
                ) : (
                  'Online Üyeleri Sıfırla'
                )}
              </Button>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                  <thead>
                    <tr>
                      <th className="border-0">Sıra</th>
                      <th className="border-0">Kullanıcı</th>
                      <th className="border-0">Durum</th>
                      <th className="border-0">Kredi</th>
                      <th className="border-0">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {onlineMembers.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center p-4">Online üye yok.</td>
                      </tr>
                    ) : (
                      onlineMembers.map((member, index) => (
                        <tr key={member.id}>
                          <td>{(currentOnlinePage - 1) * itemsPerPage + index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {member.profileImageUrl ? (
                                <img
                                  src={member.profileImageUrl}
                                  alt={member.name}
                                  className="rounded-circle"
                                  style={{ width: 32, height: 32, marginRight: 8, objectFit: 'cover' }}
                                />
                              ) : (
                                <div className="rounded-circle bg-secondary" style={{ width: 32, height: 32, marginRight: 8 }}></div>
                              )}
                              {member.name}
                              {member.isPremium && (
                                <Badge bg="warning" text="dark" className="ms-2" style={{ fontSize: '0.7rem' }}>VİP</Badge>
                              )}
                            </div>
                          </td>
                          <td>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-success"
                            />
                          </td>
                          <td>{member.credit}</td>
                          <td>
                            <div className="d-flex gap-1 flex-wrap">
                              <Button
                                size="sm"
                                variant="info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openMessageModal(member.id, member.name);
                                }}
                              >
                                <FontAwesomeIcon icon={faPhone} className="me-1" />
                                Mesaj
                              </Button>
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openCallModal(member.id, member.name);
                                }}
                              >
                                <FontAwesomeIcon icon={faPhone} className="me-1" />
                                Arama
                              </Button>
                              <Button
                                size="sm"
                                variant="success"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openCreditsModal(member.id, member.name, member.credit);
                                }}
                              >
                                <FontAwesomeIcon icon={faDollarSign} />
                              </Button>
                              <Button
                                size="sm"
                                variant="warning"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openPremiumModal(member.id, member.name, false);
                                }}
                              >
                                <FontAwesomeIcon icon={faCrown} />
                              </Button>
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openBanModal(member.id, member.name, false);
                                }}
                              >
                                <FontAwesomeIcon icon={faBan} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
              {totalOnlinePages > 1 && (
                <div className="d-flex justify-content-center p-3 bg-dark">
                  <Pagination className="mb-0" size="sm">
                    {Array.from({ length: totalOnlinePages }, (_, i) => {
                      const page = i + 1;
                      return (
                        <Pagination.Item
                          key={page}
                          active={currentOnlinePage === page}
                          onClick={() => setCurrentOnlinePage(page)}
                        >
                          {page}
                        </Pagination.Item>
                      );
                    })}
                  </Pagination>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>


      {/* Modals */}
      <Modal show={showCreditsModal} onHide={() => {
        setShowCreditsModal(false);
        setModalError(null);
      }} onEntered={() => creditsInputRef.current?.focus()}>
        <Modal.Header closeButton>
          <Modal.Title>Jeton Ekle/Sil - {targetUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <Form.Group>
            <Form.Label>
              Jeton Değişikliği (Mevcut: {targetUserCredits})
              <br />
              <small className="text-muted">Pozitif değer ekler, negatif değer çıkarır</small>
            </Form.Label>
            <Form.Control
              type="number"
              ref={creditsInputRef}
              value={creditsInput}
              onChange={(e) => setCreditsInput(e.target.value)}
              placeholder="Örn: 100 veya -50"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdateCredits();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowCreditsModal(false);
            setModalError(null);
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdateCredits}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPremiumModal} onHide={() => {
        setShowPremiumModal(false);
        setModalError(null);
      }} onEntered={() => premiumInputRef.current?.focus()}>
        <Modal.Header closeButton>
          <Modal.Title>Premium Yap/Kaldır - {targetUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <Form.Group>
            <Form.Label>Premium Gün Sayısı (0 = Premium'u Kaldır)</Form.Label>
            <Form.Control
              type="number"
              ref={premiumInputRef}
              value={premiumDaysInput}
              onChange={(e) => setPremiumDaysInput(e.target.value)}
              placeholder="10"
              min="0"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdatePremium();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowPremiumModal(false);
            setModalError(null);
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdatePremium}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBanModal} onHide={() => {
        setShowBanModal(false);
        setModalError(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetUserIsBanned ? 'Banı Kaldır' : 'Kullanıcıyı Banla'} - {targetUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          {targetUserIsBanned ? (
            <p>Bu kullanıcının banını kaldırmak istediğinizden emin misiniz?</p>
          ) : (
            <p>Bu kullanıcıyı banlamak istediğinizden emin misiniz? Banlanan kullanıcılar uygulamaya giriş yapamaz.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowBanModal(false);
            setModalError(null);
          }}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleBanUser}>
            {targetUserIsBanned ? 'Evet, Banı Kaldır' : 'Evet, Banla'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Mesaj Gönderme Modal */}
      <Modal show={showMessageModal} onHide={() => {
        setShowMessageModal(false);
        setModalError(null);
        setMessageText("");
        setFakeAccountSearch("");
      }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mesaj Gönder - {targetUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <Form.Group className="mb-3">
            <Form.Label><strong>Mesajı Gönderen Kişi</strong></Form.Label>
            <div className="mb-2">
              <Form.Label className="text-muted">Hesap Seçin</Form.Label>
            </div>
            <Form.Control
              type="text"
              placeholder="Fake hesap ara..."
              value={fakeAccountSearch}
              onChange={(e) => setFakeAccountSearch(e.target.value)}
              className="mb-2"
            />
            <Form.Select
              value={selectedFakeAccountId || ""}
              onChange={(e) => setSelectedFakeAccountId(e.target.value)}
              required
            >
              <option value="">Fake hesap seçin...</option>
              {fakeAccounts
                .filter(account =>
                  fakeAccountSearch === "" ||
                  account.name.toLowerCase().includes(fakeAccountSearch.toLowerCase())
                )
                .map(account => (
                  <option key={account.id} value={account.id}>
                    {account.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label><strong>Mesaj</strong></Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              placeholder="Mesaj..."
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowMessageModal(false);
              setModalError(null);
              setMessageText("");
              setFakeAccountSearch("");
            }}
            disabled={sendingMessage}
          >
            İptal
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSendMessage(false)}
            disabled={sendingMessage || !selectedFakeAccountId || !messageText.trim()}
          >
            {sendingMessage ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Gönderiliyor...
              </>
            ) : (
              'Gönder'
            )}
          </Button>
          <Button
            variant="info"
            onClick={() => handleSendMessage(true)}
            disabled={sendingMessage || !selectedFakeAccountId || !messageText.trim()}
          >
            {sendingMessage ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Gönderiliyor...
              </>
            ) : (
              "Gönder ve Chat'e git"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Arama Başlatma Modal */}
      <Modal show={showCallModal} onHide={() => {
        setShowCallModal(false);
        setModalError(null);
        setCallType("recorded_voice");
      }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Arama Başlat - {targetUserName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <Form.Group className="mb-3">
            <Form.Label><strong>Aramayı Başlatan Hesap</strong></Form.Label>
            <div className="mb-2">
              <Form.Label className="text-muted">Fake Hesap Seçin</Form.Label>
            </div>
            <Form.Control
              type="text"
              placeholder="Fake hesap ara..."
              value={fakeAccountSearch}
              onChange={(e) => {
                setFakeAccountSearch(e.target.value);
              }}
              className="mb-2"
            />
            <Form.Select
              value={selectedFakeAccountId || ""}
              onChange={async (e) => {
                const fakeId = e.target.value;
                setSelectedFakeAccountId(fakeId);
                if (fakeId && (callType === 'recorded_voice' || callType === 'recorded_video')) {
                  await loadRecordings(fakeId);
                }
              }}
              required
            >
              <option value="">Fake hesap seçin...</option>
              {fakeAccounts
                .filter(account =>
                  fakeAccountSearch === "" ||
                  account.name.toLowerCase().includes(fakeAccountSearch.toLowerCase())
                )
                .map(account => (
                  <option key={account.id} value={account.id}>
                    {account.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label><strong>Arama Türü</strong></Form.Label>
            <Form.Select
              value={callType}
              onChange={async (e) => {
                const newCallType = e.target.value;
                setCallType(newCallType);
                // Eğer recorded call seçildiyse ve fake hesap seçiliyse kayıtları yükle
                if ((newCallType === 'recorded_voice' || newCallType === 'recorded_video') && selectedFakeAccountId) {
                  await loadRecordings(selectedFakeAccountId);
                }
              }}
              required
            >
              <option value="normal_voice">Normal Sesli Arama</option>
              <option value="recorded_voice">Sesli Arama (Kayıtlı)</option>
              <option value="recorded_video">Videolu Arama (Kayıtlı)</option>
            </Form.Select>
          </Form.Group>

          {loadingRecordings && (
            <div className="text-center mb-3">
              <Spinner animation="border" size="sm" className="me-2" />
              Kayıtlar yükleniyor...
            </div>
          )}

          {callType === 'normal_voice' && (
            <Form.Group className="mb-3">
              <Alert variant="info">
                Normal sesli arama başlatılacak. Kayıt gerekmez.
              </Alert>
            </Form.Group>
          )}

          {callType === 'recorded_voice' && (
            <Form.Group className="mb-3">
              <Form.Label><strong>Ses Kayıtları</strong></Form.Label>
              {audioRecordings.length === 0 ? (
                <Alert variant="warning">
                  Bu fake hesapta ses kaydı bulunamadı. Lütfen önce ses kaydı ekleyin.
                </Alert>
              ) : audioRecordings.length === 1 ? (
                <Alert variant="info">
                  Kullanılacak kayıt: {audioRecordings[0].title || 'İsimsiz'}
                </Alert>
              ) : (
                <Alert variant="info">
                  Toplam {audioRecordings.length} ses kaydı var. İlk kayıt kullanılacak.
                </Alert>
              )}
            </Form.Group>
          )}

          {callType === 'recorded_video' && (
            <Form.Group className="mb-3">
              <Form.Label><strong>Video Kayıtları</strong></Form.Label>
              {videoRecordings.length === 0 ? (
                <Alert variant="warning">
                  Bu fake hesapta video kaydı bulunamadı. Lütfen önce video kaydı ekleyin.
                </Alert>
              ) : videoRecordings.length === 1 ? (
                <Alert variant="info">
                  Kullanılacak kayıt: {videoRecordings[0].title || 'İsimsiz'}
                </Alert>
              ) : (
                <Alert variant="info">
                  Toplam {videoRecordings.length} video kaydı var. İlk kayıt kullanılacak.
                </Alert>
              )}
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCallModal(false);
              setModalError(null);
              setCallType("recorded_voice");
            }}
          >
            İptal
          </Button>
          <Button
            variant="primary"
            onClick={handleStartCall}
            disabled={!selectedFakeAccountId || loadingRecordings ||
              (callType === 'recorded_voice' && audioRecordings.length === 0) ||
              (callType === 'recorded_video' && videoRecordings.length === 0)}
          >
            Arama Başlat
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
